module.exports = __webpack_public_path__ + "img/discovery-banner.29ee5c8d.png";